// import React from "react";
import "./EventOneFooter.scss";

const Footer = () => {
  return (
    <footer className="eventOne-footer">
      {/* Include Material Symbols Font */}
      <link
        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined"
        rel="stylesheet"
      />

      <div className="eventOne-footer-top-banner">
        <h3>Get connected with us</h3>
        <div className="eventOne-social-icons">
          <a
            href="https://facebook.com/yourprofile"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img
              src="https://img.icons8.com/color/48/facebook.png"
              alt="Facebook"
              className="social-icon"
            />
          </a>
          <a
            href="https://linkedin.com/in/yourprofile"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <img
              src="https://img.icons8.com/color/48/linkedin.png"
              alt="LinkedIn"
              className="social-icon"
            />
          </a>
          <a
            href="https://instagram.com/yourprofile"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img
              src="https://img.icons8.com/color/48/instagram-new--v1.png"
              alt="Instagram"
              className="social-icon"
            />
          </a>
          <a
            href="https://youtube.com/yourchannel"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <img
              src="https://img.icons8.com/color/48/youtube-play.png"
              alt="YouTube"
              className="social-icon"
            />
          </a>
          {/* <a
            href="https://x.com/yourprofile"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/000000/x.png"
              alt="X"
              className="social-icon"
            />
          </a> */}
        </div>
      </div>

      <div className="eventOne-footer-content">
        <div className="eventOne-footer-column brand">
          <img
            src="./assets/img/eventify/sportszone_logo.png"
            alt="/"
            className="eventOne-footer-logo"
          />
          <h4>SPORTS ZONE</h4>
          <p>
            "Thank you for visiting [SPORTS ZONE], your ultimate destination for
            the latest sports news, live scores, and in-depth analysis. Our
            mission is to provide fans with accurate, up-to-date coverage of all
            your favorite sports, teams, and athletes.
          </p>
        </div>

        <div className="eventOne-footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a href="#">Home</a>
            </li>
            <li>
              <a href="#">FAQ</a>
            </li>
            <li>
              <a href="#">Gallery</a>
            </li>
            <li>
              <a href="#">Notifications</a>
            </li>
            <li>
              <a href="#">Live Scores</a>
            </li>
          </ul>
        </div>

        <div className="eventOne-footer-column">
          <h4>Useful Links</h4>
          <ul>
            <li>
              <a href="#">About Us</a>
            </li>
            <li>
              <a href="#">Disclaimer</a>
            </li>
            <li>
              <a href="#">Contact Us</a>
            </li>
            <li>
              <a href="#">Privacy Policy</a>
            </li>
            <li>
              <a href="#">Terms & Conditions</a>
            </li>
          </ul>
        </div>

        <div className="eventOne-footer-column contact">
          <h4>Contact</h4>

          <p className="address">
            <span class="material-symbols-outlined">location_on</span>
            PAP-G-18/3 Chakan Industrial Area
            <br />
            MIDC PH-II Sawardari, Near Bridgestone Company
            <br />
            Tal-Khed, Pune, Maharashtra 410501
          </p>
          <p className="mail-para">
            <span className="material-symbols-outlined">mail</span>{" "}
            sportszone@gmail.com
          </p>
          <p>
            <span className="material-symbols-outlined">call</span> +91 9022 11
            8383
          </p>
        </div>
      </div>

      <div className="eventOne-footer-bottom">
        <p className="copyright">© 2025 All rights reserved</p>
        <p>
          Design & Developed by{" "}
          <a href="https://hypercloud.in" target="_blank" rel="noreferrer">
            HyperCloud Digital Solutions
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

// // import React from "react";
// import "./EventOneFooter.scss";
// import {
//   FaPinterestP,
//   FaFacebookF,
//   FaInstagram,
//   FaTwitter,
// } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <footer className="eventOne_footer">
//       <div className="eventOne_footer_top">
//         <div className="eventOne_footer_columns">
//           <div className="eventOne_footer_column">
//             <h4>Shop</h4>
//             <ul>
//               <li>Starter Kits</li>
//               <li>Jerseys & Merchandise</li>
//               <li>Fan Gear</li>
//               <li>Tickets</li>
//               <li>Shop All</li>
//             </ul>
//             <p className="eventOne_copyright">
//               © 2025 SportsZone. All rights reserved.
//             </p>
//           </div>

//           <div className="eventOne_footer_column">
//             <h4>Learn</h4>
//             <ul>
//               <li>Our Story</li>
//               <li>Training Tips</li>
//               <li>Player Spotlights</li>
//               <li>Health & Fitness</li>
//               <li>FAQ's</li>
//             </ul>
//           </div>

//           <div className="eventOne_footer_column">
//             <h4>More from Tenzo</h4>
//             <ul>
//               <li>Sign In</li>
//               <li>Wholesale Opportunities</li>
//               <li>Affiliate</li>
//               <li>Contact Us</li>
//             </ul>
//           </div>

//           <div className="eventOne_footer_column eventOne_footer_socials">
//             <h4>Follow us</h4>
//             <div className="eventOne_social-icons">
//               <a href="#">
//                 <FaPinterestP />
//               </a>
//               <a href="#">
//                 <FaFacebookF />
//               </a>
//               <a href="#">
//                 <FaInstagram />
//               </a>
//               <a href="#">
//                 <FaTwitter />
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="eventOne_footer_bottom">
//         <a href="#">Terms of Service</a> |<a href="#"> Privacy Policy</a> |
//         <a href="#"> Refund Policy</a> |<a href="#"> Accessibility Policy</a>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

// const Footer = () => {
//   return (
//     <div className="Footer-events">
//       <div className="container">
//         <div className="Footer_inner">
//           <div className="footer_header">
//             <div className="left">
//               <h2 className="title_footer">Sports</h2>
//               <p className="para_card_para">Zone</p>
//               {/* <h6 className="sub_title">Explore. Discover. Make a Plan</h6> */}
//             </div>

//             <div className="right">
//               <img
//                 src="./assets/img/ecommerce/ecomTwo/icons/bookmark.png"
//                 alt=""
//                 className="icon"
//               />
//             </div>
//           </div>

//           <div className="footer_define">
//             <p className="def">
//               We bring you the latest scores, news, stats, and insights from the
//               world of sports. Whether you're a fan of football, basketball,
//               soccer, or beyond—we’ve got you covered 24/7.
//             </p>
//           </div>
//           <div className="second_inner">
//             <div className="title">For Event Organizer</div>
//             <div className="footer_define">
//               <p className="def">
//                 Paytm Insider is a platform that helps you discover and buy the
//                 best in events, travel and food in your city. We strive to
//                 curate experiences that are worth your time and money, possibly
//                 something you have never tried before.
//               </p>
//             </div>
//           </div>
//           <div className="btn_footer">
//             <button className="btn_item">About Us</button>
//             <button className="btn_item">Blog</button>
//             <button className="btn_item">Careers</button>
//             <button className="btn_item"> Privacy Policy </button>
//             <button className="btn_item"> Terms And Condition </button>
//             <button className="btn_item">List with Us </button>
//             <button className="btn_item">Contact Us</button>
//             <button className="btn_item">FAQs</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default Footer;
